<template>
  <button
    class="default-button"
    :class="[typeClass, { 'disabled': isDisabled || isLoading }]"
    :disabled="isDisabled || isLoading"
    :loading="isLoading"
    @click="$emit('click', $event)">
    <i
      v-if="isLoading"
      class="el-icon-loading" />
    <slot />
  </button>
</template>

<script>
export default {
  name: "DefaultButton",
  props: {
    nativeType: {
      type: String,
      required: false,
      default: "button",
      validator: (value) => ["button", "submit", "reset"].indexOf(value) !== -1
    },
    designType: {
      type: String,
      required: false,
      default: "primary",
      validator: (value) => ["primary", "secondary"].indexOf(value) !== -1
    },
    iconClass: {
      type: String,
      required: false,
      default: null,
      validator: (value) => value.includes("el-icon-")
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    typeClass() {
      return "design-type-" + this.designType
    }
  }
}
</script>

<style lang="scss" scoped>
button.default-button {
  border: none;
  color: color(plainWhite);
  cursor: pointer;
  font-weight: 500;
  border-radius: 16px; /* 50% of button's height */
  font-size: 12px;
  padding: 7px 16px;
  transition: color 300ms, filter 300ms;

  &.design-type-primary {
    $color: var(--theme-color);
    background-color: $color;
  }

  &.design-type-secondary {
    $color: color(deepSeaBlue);
    background-color: $color;
  }

  &:hover,
  &:focus {
    filter: brightness(1.05);
  }
  &:active {
    filter: brightness(0.95);
  }
}

:disabled,
.disabled {
  background-color: color(gray05) !important;
  color: color(gray03) !important;
  cursor: not-allowed !important;
}
</style>
